// extracted by mini-css-extract-plugin
export var banner = "_43-0";
export var icon = "_43-1";
export var message = "_43-2";